import React from 'react';
import dataAids from '../../../../constants/dataAids';
import FormattedNumber from '../../FormattedNumber';
import SaleDelta from './SaleDelta';
import ProductLabels from './ProductLabels';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';

const PricesAndShipping = ({
  product,
  prices,
  translate,
  children,
  showProductLabels,
  isQuickView
}) => {
  const { Block } = UX2.Element;
  const styles = {
    wrapper: {
      'marginBottom': isQuickView ? 'medium' : 'large',
      'textAlign': 'center',
      '@sm': {
        textAlign: 'left'
      }
    },
    pricesContainer: {
      paddingBottom: 'small'
    },
    price: {
      textAlign: 'center'
    },
    salePrice: {
      marginLeft: 'small'
    },
    labelsContainer: {
      '@xs-only': {
        display: 'none'
      }
    }
  };

  return (
    <Block style={ styles.wrapper }>
      <Block style={ styles.pricesContainer }>
        <FormattedNumber
          element={ UX2.Element.Price.Major }
          data-aid={ dataAids.PRODUCT_PRICE_RENDERED }
          number={ prices.price }
          currency={ true }
          style={ styles.price }
          expired={ !!prices.onSale }
        />
        { prices.onSale && (
          <FormattedNumber
            element={ UX2.Element.Price.Major }
            number={ prices.salePrice }
            data-aid={ dataAids.PRODUCT_SALE_PRICE_RENDERED }
            currency={ true }
            style={ styles.salePrice }
          />
        ) }
        <SaleDelta prices={ prices } translate={ translate } />
        { children }
      </Block>
      { showProductLabels && (product.ship_free || product.limited_edition || product.free_return) && (
        <Block style={ styles.labelsContainer }>
          <ProductLabels product={ product } translate={ translate } />
        </Block>
      ) }
    </Block>
  );
};

PricesAndShipping.propTypes = {
  showProductLabels: PropTypes.bool,
  isQuickView: PropTypes.bool,
  product: PropTypes.object,
  prices: PropTypes.object,
  translate: PropTypes.func,
  children: PropTypes.any
};

export default PricesAndShipping;
